/**
 * A WITHDRAWN notification: the server answers its owner 410
 * NOTIFICATION_UNAVAILABLE and never returns its content. It opens only on the
 * neutral "no longer available" page at /n/:id.
 *
 * Import-free (the status is duck-typed rather than read with axios's
 * isAxiosError), so react-scripts' jest can collect every caller.
 */
export const NOTIFICATION_UNAVAILABLE = "unavailable" as const;

export const isNotificationUnavailableError = (error: unknown): boolean =>
  (error as { response?: { status?: unknown } } | null)?.response?.status === 410;

export const notificationItemQueryKey = (id: string | undefined) =>
  ["notifications", "item", id] as const;

export const notificationLinkPath = (id: string): string => `/n/${encodeURIComponent(id)}`;
